import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
import styles from './CheckboxNormal.scss';

const CheckboxNormal = ({
  name,
  value,
  onChange,
  label,
  inputProps,
  disabled,
  className,
  formElement,
  previewIdsTable,
  additionalComponent,
  inline,
  checkboxClassname,
  checkboxContainerClassname,
  checkboxSpanClassname,
  checkboxSpanTextClassname,
  checkerClassname,
  enableWrapperClick,
  tooltipTitle = '',
  chosenColor = true,
}) => {
  const resolvedTooltipTitle = useHelpNoteTitle(label, tooltipTitle);
  const _onChange = useCallback(
    e => {
      if (e.target.tagName === 'SPAN' || disabled) return;
      onChange({ target: { name, checked: !value } });
    },
    [onChange, value, name, disabled],
  );

  return (
    <div
      className={classnames('form-group-material', checkboxContainerClassname, {
        'form-group': !!formElement,
        inline,
        'mr-10': inline,
      })}
    >
      <div
        className={classnames('checkbox', checkboxClassname, {
          [styles.wrapperClick]: enableWrapperClick,
        })}
        onClick={enableWrapperClick && _onChange}
      >
        <label className={className} title={resolvedTooltipTitle}>
          <div
            className={classnames('checker', checkerClassname, {
              [styles.checkboxPosition]: previewIdsTable,
              disabled,
              [styles.top2]: !value,
            })}
          >
            <span
              className={classnames(checkboxSpanClassname, {
                checked: value,
                'checkbox-chosen-color': !value && disabled && chosenColor,
                'checked-border': value && disabled,
              })}
            >
              <input
                className="styled"
                name={name}
                type="checkbox"
                {...inputProps}
                checked={value}
                disabled={disabled}
                onChange={onChange}
              />
            </span>
            &nbsp;
          </div>
          {additionalComponent && additionalComponent}
          &nbsp;
          <span
            className={classnames('text', checkboxSpanTextClassname, {
              [styles.wrapperClickSpan]: enableWrapperClick,
            })}
          >
            {label}
          </span>
        </label>
      </div>
    </div>
  );
};

export default CheckboxNormal;

CheckboxNormal.propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  inputProps: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  formElement: PropTypes.bool,
  previewIdsTable: PropTypes.bool,
  additionalComponent: PropTypes.elementType,
  inline: PropTypes.bool,
  tooltipTitle: PropTypes.string,
};

CheckboxNormal.defaultProps = {
  name: null,
  value: false,
  label: null,
  inputProps: {},
  disabled: false,
  className: null,
  formElement: false,
  previewIdsTable: false,
  additionalComponent: null,
  inline: false,
  tooltipTitle: '',
};
